"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BaseHeader_component_exports = {};
__export(BaseHeader_component_exports, {
  BaseHeader: () => BaseHeader,
  default: () => BaseHeader_component_default
});
module.exports = __toCommonJS(BaseHeader_component_exports);
var import_react = __toESM(require("react"));
var import_atoms = require("../../../atoms");
var import_useBreakpoints = require("../../../../utils/useBreakpoints/useBreakpoints.hook");
var import_BaseHeader = require("./BaseHeader.styled");
var _excluded = ["toggleOpen", "logoSrc", "buttonRef", "hideHamburgerMenu", "darkMode"];
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var BaseHeader = /* @__PURE__ */ (0, import_react.forwardRef)(function(_ref, heightRef) {
  var toggleOpen = _ref.toggleOpen, _ref$logoSrc = _ref.logoSrc, logoSrc = _ref$logoSrc === void 0 ? void 0 : _ref$logoSrc, buttonRef = _ref.buttonRef, _ref$hideHamburgerMen = _ref.hideHamburgerMenu, hideHamburgerMenu = _ref$hideHamburgerMen === void 0 ? false : _ref$hideHamburgerMen, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, props = _objectWithoutProperties(_ref, _excluded);
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var hamburgerMenuButton = /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
    value: "Main Menu",
    placement: "bottom",
    offset: [25, 5]
  }, /* @__PURE__ */ import_react.default.createElement(import_atoms.Button, {
    className: "sidemenu-toggle-button",
    icon: "hamburguer",
    variant: "empty",
    circle: true,
    size: "40px",
    onClick: toggleOpen,
    ref: buttonRef,
    darkMode,
    iconSize: 26,
    ariaLabel: "Main Menu",
    "aria-expanded": props.ariaExpanded,
    "aria-controls": "hamburger-menu-id-controls"
  }));
  return /* @__PURE__ */ import_react.default.createElement(import_BaseHeader.StyledBaseHeaderContainer, {
    className: props.className,
    ref: heightRef
  }, /* @__PURE__ */ import_react.default.createElement(import_BaseHeader.StyledResponsiveLogoContainer, null, /* @__PURE__ */ import_react.default.createElement(import_BaseHeader.StyledResponsiveLogo, {
    darkMode,
    src: logoSrc,
    responsive: true
  })), /* @__PURE__ */ import_react.default.createElement(import_BaseHeader.StyledHeaderContent, null, (!hideHamburgerMenu || breakpoints.isLg || breakpoints.isXl) && /* @__PURE__ */ import_react.default.createElement(import_BaseHeader.StyledMenuContainer, null, !hideHamburgerMenu && hamburgerMenuButton, /* @__PURE__ */ import_react.default.createElement(import_BaseHeader.StyledLogo, {
    darkMode,
    src: logoSrc
  })), props.children));
});
var BaseHeader_component_default = BaseHeader;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BaseHeader
});
//# sourceMappingURL=BaseHeader.component.js.map